import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import { useCallback, useMemo } from "react";

// Module-level guard: loadFull only runs once per session regardless of remounts
let engineLoaded = false;

const ParticlesComponent = ({ id }) => {
  const particlesInit = useCallback(async (engine) => {
    if (!engineLoaded) {
      await loadFull(engine);
      engineLoaded = true;
    }
  }, []);

  const options = useMemo(() => ({
    fpsLimit: 120,
    pauseOnBlur: false,
    pauseOnOutsideViewport: false,
    interactivity: {
      events: {
        onClick: { enable: true, mode: "repulse" },
        onHover: { enable: true, mode: "grab" },
      },
      modes: { push: { distance: 200, duration: 15 }, grab: { distance: 150 } },
    },
    particles: {
      color: { value: "#11b36d" },
      links: { color: "#11b36d", distance: 150, enable: true, opacity: 0.3, width: 2 },
      move: {
        direction: "none",
        enable: true,
        outModes: { default: "bounce" },
        random: true,
        speed: 1,
        straight: false,
      },
      number: { density: { enable: true }, value: 150 },
      opacity: { value: 1.0 },
      shape: { type: "circle" },
      size: { value: { min: 1, max: 3 } },
    },
    detectRetina: true,
  }), []);

  return <Particles id={id || "tsparticles"} init={particlesInit} options={options} />;
};

export default ParticlesComponent;
